import { render, staticRenderFns } from "./LmWidget.vue?vue&type=template&id=976bc53a&"
import script from "./LmWidget.vue?vue&type=script&lang=js&"
export * from "./LmWidget.vue?vue&type=script&lang=js&"
import style0 from "./LmWidget.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports